import React from 'react';
import UIRegions from 'shared/constants/UIRegions';
import Modal from 'shared/components/misc/modal.jsx';
import TeleprompterActivation from 'shared/components/misc/teleprompterActivation';

/**
 * Global Elements Activation Modal
 */
export default React.createClass({
  displayName: 'TeleprompterActivationModal',

  render() {
    return (
      <Modal
        className="modal-generic-wrapper upgrade-alert-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.TeleprompterActivationModal}
      >
        <TeleprompterActivation />
      </Modal>
    );
  },
});
